import React, { useEffect, useState } from "react";
import Navbar from "../navbar/Navbar";
import Sidebar from "../sidebar/Sidebar";
// import Footer from "../footer/Footer";
import { useSidebar } from "../../context/SidebarContext";

export default function Layout({ children }) {

  const {sidebarWidth} = useSidebar();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="flex">
      <Sidebar />
      <div className={`w-full ml-[${sidebarWidth}] transition-all duration-300`} style={{marginLeft : isMobile ? "0px" : sidebarWidth}}>
        <Navbar />
        {children}
        {/* <Footer /> */}
      </div>
    </div>
  );
}
